import React from "react";
import "./PorDentroDaPlataforma.css";
import img1 from '../../assets/imgs/1f4f1.svg';
import img2 from '../../assets/imgs/1f4d7.svg';
import img3 from '../../assets/imgs/1f4bb.svg';
function PorDentroDaPlataforma({ onScroll }) {
  return (
    <div className="por-dentro-wrapper">
      <div className="por-dentro-container">
        <h2>Confira como é por dentro da Plataforma Insigne de Pesquisa:</h2>
        <iframe src="https://www.youtube.com/embed/75g_v8doknI?si=jvwwc_TDfbW8eiAq" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        <div className="plataform-icons">
          <div>
            <img alt='insigne' src={img3}></img> <h3>Aulas curtas e dinâmicas</h3>
          </div>
          <div>
            <img alt='insigne' src={img2}></img > <h3>Material objetivo e fácil de compreender</h3>
          </div>
          <div>
            <img alt='insigne' src={img1}></img> <h3>Acesso em qualquer dispositivo</h3>
          </div>
        </div>
        <button onClick={onScroll} className="main-btn">
          PERFEITA DEMAIS! QUERO ELA PRA MIM!
        </button>
      </div>
    </div>
  );
}

export default PorDentroDaPlataforma;
